import React, {useContext} from 'react'
import "./ContactForm.scss";
import { FormContext } from '../../App';
import Form from './Form';
const ContactForm = () => {
  const {formOpen, setFormOpen}=useContext(FormContext);
  return (
    <>
  
<div className={` ${formOpen? "formWrapper":"formHidden"}`}>
<div className="formbackground" onClick={()=>setFormOpen(!formOpen)}>

</div>

        <div className="contactForm">
          <Form/>
        </div>
    </div>
    </>
    
  )
}

export default ContactForm